<template>
    <div v-show="isRenewAccountLicenseFailedModalVisible">
        <transition name="slide">
            <div class="modal-mask">
                <div class="modal-dialog modal-dialog-slideout modal-lg">
                    <div class="modal-content p-2">
                        <div class="modal-header">
                            <div class="maheading_1">
                                <h5 class="modal-title">Renew subscriptions</h5>
                            </div>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-12">
                                    <div class="successPanel">
                                        <div class="success_col_1">
                                            <p class="success-note">
                                                Your payment transaction has failed and the subscription is not renewed.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row justify-content-md-center closebtn_div">
                                <div class="col-6">
                                    <button type="button" class="btn btn-sm btn-blue closeBtn text-center" @click="closeModal">Close Window</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>
<script>
export default {
    props: ['isRenewAccountLicenseFailedModalVisible', 'landingPage'],
    data() {
        return {
            loading: false,
        }
    },
    methods: {
        closeModal() {
            let routeData = this.$router.resolve({name: this.landingPage});
            window.open(routeData.href, '_self');
        },
    },
}
</script>
<style scoped>
::-webkit-scrollbar {
    width: 0;  /* Remove scrollbar space */
    background: transparent;  /* Optional: just make scrollbar invisible */
}
.modal-mask {
    position: fixed;
    z-index: 1001;
    top: 59px;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    transition: opacity .3s ease;
    overflow-y: scroll;
}
.modal-dialog {
  max-width: 90%;
}
@media (min-width: 992px) {
    .modal-lg, .modal-xl { width: 700px; }
}
@media (max-width: 576px){ 
    .modal-dialog.modal-dialog-slideout { width: 80% }
}
.modal-dialog-slideout {
    min-height: 100%; margin: 0 0 0 auto; background: #fff; 
}
.modal-dialog-slideout .modal-content{ border: 0; }
.modal-header { border-bottom: none; }
.modal-footer { border-top: none; }
.modal-title { font-weight: 900; }
.maheading_1 { width: 80%; }
.maheading_3 { width: 20%; }
.closeBtn {
    color: #00acee; 
    background-color: #FFF !important;
    border: 1px solid #00acee !important;
    border-radius: 10px;
    font-weight: 900;
    width: 100%;
}
.successPanel { 
    padding: 20px;
    border-radius: 10px;
}
.success-note { font-size: 1.05rem; text-align: center; margin: 2rem 0; color: #dc3545; font-weight: 900; }
.success_col_1 { width: 100%; text-align: center;}
.closebtn_div { margin: 8rem; }
</style>



// WEBPACK FOOTER //
// src/components/enterpriseadmin/renew_account_license_failed_modal.vue